function initActivityFilter() {
    function filterActivity() {
        $('#activityFilters').addClass('loading');


        var targetUrl = $('#activityFilters').data('group-activity-url');
        var currentSeason = $('#filterSeason').val();
        var currentTheme = $('#filterTheme').val();

        targetUrl = addParameterToURL(targetUrl, 'season', currentSeason);
        targetUrl = addParameterToURL(targetUrl, 'theme', currentTheme);

        window.location.href = targetUrl;
    }

    $('#submitActivityFilter').on('click', function () {
        filterActivity();
    });

    $('.form__container').on('click', function () {
        $(this).find('.form__label').addClass("form__label--selected");
    });

    $('.form__field').each(function () {
        if ($(this).hasClass('filled')) {
            $(this).find('.form__label').addClass("form__label--selected");
        }
    });
}



